import * as React from 'react';
import type { StepManagerHeaderProps } from './step-manager.types';
import type { TAllowedColors } from '@components/atoms';

const PROGRESS_SEGMENT_COLOR_MAP: Partial<Record<TAllowedColors, string>> = {
	green: 'var(--color-success)',
	blue: 'var(--color-highlightSelected)',
	gray: 'var(--color-lightGray)',
};

const SEGMENT_HEIGHT_PX = 4;
const SEGMENT_GAP_PX = 4;
const SEGMENT_BORDER_RADIUS = 1000;

type SegmentState = 'done' | 'current' | 'disabled';

function getSegmentState(index: number, currentIndex: number): SegmentState {
	if (index < currentIndex) return 'done';
	if (index === currentIndex) return 'current';
	return 'disabled';
}

export const StepManagerHeader: React.VoidFunctionComponent<StepManagerHeaderProps> = ({
	currentIndex,
	totalSteps,
	doneColor = 'green',
	currentColor = 'blue',
	disabledColor = 'gray',
}) => {
	const colorForState: Record<SegmentState, string> = {
		done: PROGRESS_SEGMENT_COLOR_MAP[doneColor] ?? '#24C875',
		current: PROGRESS_SEGMENT_COLOR_MAP[currentColor] ?? '#0571E0',
		disabled: PROGRESS_SEGMENT_COLOR_MAP[disabledColor] ?? '#F0F0F0',
	};

	return (
		<div className="flex w-full flex-col gap-2">
			<p className="w-full text-center text-sm font-semibold" style={{ color: colorForState.current }}>
				Step {currentIndex + 1} of {totalSteps}
			</p>
			<div className="flex w-full" style={{ gap: `${SEGMENT_GAP_PX}px` }}>
				{Array.from({ length: totalSteps }, (_, index) => {
					const state = getSegmentState(index, currentIndex);
					return (
						<div key={index} className="relative min-w-0 flex-1" style={{ height: `${SEGMENT_HEIGHT_PX}px` }}>
							<div
								className="absolute inset-0"
								style={{
									backgroundColor: colorForState[state],
									borderRadius: `${SEGMENT_BORDER_RADIUS}px`,
								}}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};
